module.exports = __webpack_public_path__ + "static/media/enggar.ff96fb5b.jpeg";